export default "__VITE_ASSET__Dwag$Ylc__"